import PropTypes from "prop-types";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Scroll-reveal wrapper. Fades and lifts children into view once.
 * Honours prefers-reduced-motion by rendering without motion.
 */
const Reveal = ({ as = "div", delay = 0, y = 16, className, children, ...rest }) => {
  const reduce = useReducedMotion();
  const Component = motion[as] || motion.div;

  if (reduce) {
    const Static = as;
    return (
      <Static className={className} {...rest}>
        {children}
      </Static>
    );
  }

  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -80px 0px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
      {...rest}
    >
      {children}
    </Component>
  );
};

Reveal.propTypes = {
  as: PropTypes.string,
  delay: PropTypes.number,
  y: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Reveal;
